export const KeyIndicators = {
  "report": [
    {
      "noma_code": "M16S505",
      "noma_name": "(505) ПАРФЮМЕРИЯ КОСМЕТИКА",
      "vendor_code": null,
      "vendor_name": null,
      "mo_sls": 11322999.98,
      "mo_sls_prog": -0.2461594463463682,
      "mo_sls_share": 1,
      "qu_sls_itm": 61558,
      "qu_sls_itm_prog": -0.16464697181473992,
      "qu_sls_itm_share": 1,
      "pct_mrgn_frnt": 0.03036084523599902,
      "pct_mrgn_back": 0,
      "pct_mrgn_total": 0.03036084523599902,
      "pct_mrgn_total_prog": -0.0313024759666641,
      "pct_mrgn_net": 0.031311488492220076,
      "pct_mrgn_net_prog": -0.03440407245302273,
      "mo_sls_promo_share": 0.9528752865015901,
      "mo_sls_promo_share_prog": -0.32723956076523814
    }
  ],
  "Error": 0,
  "Msg": "",
  "Version": "1"
};
export const KeyIndicatorsSuppier = {
  "report": [
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "9791",
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_sls": 201729288.69,
      "mo_sls_prog": -0.014635303388408795,
      "mo_sls_share": 0.17795388018418148,
      "qu_sls_itm": 4622551,
      "qu_sls_itm_prog": -0.07764239817114818,
      "qu_sls_itm_share": 0.35823872560086684,
      "pct_mrgn_frnt": 0.007516905848660582,
      "pct_mrgn_back": 0.15297194225188243,
      "pct_mrgn_total": 0.160488848100543,
      "pct_mrgn_total_prog": -0.015059786811916678,
      "pct_mrgn_net": 0.16170436458444173,
      "pct_mrgn_net_prog": -0.01394983276861259,
      "mo_sls_promo_share": 0.0022260641125348927,
      "mo_sls_promo_share_prog": -0.01917766435961154
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "730",
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_sls": 194894560.72,
      "mo_sls_prog": 0.020184810446856667,
      "mo_sls_share": 0.17192467951548776,
      "qu_sls_itm": 3094611,
      "qu_sls_itm_prog": -0.1840859625370602,
      "qu_sls_itm_share": 0.23982634282897564,
      "pct_mrgn_frnt": 0.024679676139911927,
      "pct_mrgn_back": 0.13953236041856018,
      "pct_mrgn_total": 0.1642120365584721,
      "pct_mrgn_total_prog": -0.011872885181933553,
      "pct_mrgn_net": 0.16836728666594328,
      "pct_mrgn_net_prog": -0.01698716571365191,
      "mo_sls_promo_share": null,
      "mo_sls_promo_share_prog": -0.049148165164863096
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "675",
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО",
      "mo_sls": 167032347.02,
      "mo_sls_prog": 0.45814192329718345,
      "mo_sls_share": 0.14734625032142476,
      "qu_sls_itm": 1450149,
      "qu_sls_itm_prog": 0.6831446855870328,
      "qu_sls_itm_share": 0.11238373134041603,
      "pct_mrgn_frnt": 0.10121984460875476,
      "pct_mrgn_back": 0,
      "pct_mrgn_total": 0.10121984460875476,
      "pct_mrgn_total_prog": 0.020882926954914595,
      "pct_mrgn_net": 0.11261913606080126,
      "pct_mrgn_net_prog": 0.0252644088830048,
      "mo_sls_promo_share": 0.2440203338884988,
      "mo_sls_promo_share_prog": 0.13202794706201093
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "2514",
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_sls": 104595179.82,
      "mo_sls_prog": 0.02754347481075621,
      "mo_sls_share": 0.09226780215407498,
      "qu_sls_itm": 623387.572,
      "qu_sls_itm_prog": -0.046834227804127715,
      "qu_sls_itm_share": 0.048311326224134386,
      "pct_mrgn_frnt": 0.09385354991399832,
      "pct_mrgn_back": 0,
      "pct_mrgn_total": 0.09385354991399832,
      "pct_mrgn_total_prog": 0.008849778618327322,
      "pct_mrgn_net": 0.10357437244839479,
      "pct_mrgn_net_prog": 0.010673693047737904,
      "mo_sls_promo_share": 0.4013166107868163,
      "mo_sls_promo_share_prog": 0.2694771792400557
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "9839",
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_sls": 103581893.35,
      "mo_sls_prog": 0.11487356943562613,
      "mo_sls_share": 0.09137393959080718,
      "qu_sls_itm": 322083.844,
      "qu_sls_itm_prog": 0.19498662050578874,
      "qu_sls_itm_share": 0.02496087242978788,
      "pct_mrgn_frnt": 0.08236844707183565,
      "pct_mrgn_back": 0,
      "pct_mrgn_total": 0.08236844707183565,
      "pct_mrgn_total_prog": 0.0005171038281711211,
      "pct_mrgn_net": 0.08976200394264751,
      "pct_mrgn_net_prog": 0.0006137569334632553,
      "mo_sls_promo_share": 0.14579810555277903,
      "mo_sls_promo_share_prog": 0.03979747761581151
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "1154",
      "vendor_name": "Л'ОРЕАЛЬ ЗАО 2",
      "mo_sls": 103254258.34,
      "mo_sls_prog": -0.20111037080252148,
      "mo_sls_share": 0.09108491898456651,
      "qu_sls_itm": 491331.591,
      "qu_sls_itm_prog": -0.25447708217273934,
      "qu_sls_itm_share": 0.03807724414663815,
      "pct_mrgn_frnt": 0.12716420263040554,
      "pct_mrgn_back": 0,
      "pct_mrgn_total": 0.12716420263040554,
      "pct_mrgn_total_prog": 0.04442675534889805,
      "pct_mrgn_net": 0.1456908653536342,
      "pct_mrgn_net_prog": 0.05549046740181727,
      "mo_sls_promo_share": 0.1511231646119439,
      "mo_sls_promo_share_prog": -0.15551393093275886
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "208",
      "vendor_name": "ХЕНКЕЛЬ РУС ООО",
      "mo_sls": 81077941.52,
      "mo_sls_prog": -0.02029406541908192,
      "mo_sls_share": 0.07152225829240916,
      "qu_sls_itm": 448108.134,
      "qu_sls_itm_prog": -0.09118206247832444,
      "qu_sls_itm_share": 0.0347275101682042,
      "pct_mrgn_frnt": 0.101300008806637,
      "pct_mrgn_back": 0,
      "pct_mrgn_total": 0.101300008806637,
      "pct_mrgn_total_prog": -0.04061911879082261,
      "pct_mrgn_net": 0.11271838188417367,
      "pct_mrgn_net_prog": -0.044904185811334374,
      "mo_sls_promo_share": 0.3835448295431761,
      "mo_sls_promo_share_prog": 0.15500562488873607
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "3147",
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_sls": 64753244.85,
      "mo_sls_prog": -0.1043534385041037,
      "mo_sls_share": 0.05712155756064529,
      "qu_sls_itm": 489853,
      "qu_sls_itm_prog": -0.23926800316802985,
      "qu_sls_itm_share": 0.037962656215531514,
      "pct_mrgn_frnt": 0.054105412294253544,
      "pct_mrgn_back": 0.15224015171496075,
      "pct_mrgn_total": 0.20634556400921428,
      "pct_mrgn_total_prog": -0.1445646685861148,
      "pct_mrgn_net": 0.21814858303577192,
      "pct_mrgn_net_prog": -0.14198484739255915,
      "mo_sls_promo_share": 0.29555941797718266,
      "mo_sls_promo_share_prog": 0.22879899801654496
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "4153",
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_sls": 43542293.86,
      "mo_sls_prog": -0.15955403807732146,
      "mo_sls_share": 0.0384104866220696,
      "qu_sls_itm": 719872,
      "qu_sls_itm_prog": -0.26183478975982805,
      "qu_sls_itm_share": 0.0557886820233562,
      "pct_mrgn_frnt": 0.09289152480126135,
      "pct_mrgn_back": 0.16562485024761164,
      "pct_mrgn_total": 0.258516375048873,
      "pct_mrgn_total_prog": 0.04812787271165714,
      "pct_mrgn_net": 0.28498948264399643,
      "pct_mrgn_net_prog": 0.06432628544450326,
      "mo_sls_promo_share": 0.061473019281120624,
      "mo_sls_promo_share_prog": 0.014170834958395093
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "14014",
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_sls": 30738512.63,
      "mo_sls_prog": -0.24918443952714348,
      "mo_sls_share": 0.02711573331329615,
      "qu_sls_itm": 310339,
      "qu_sls_itm_prog": -0.20337042598796093,
      "qu_sls_itm_share": 0.024050669828033788,
      "pct_mrgn_frnt": 0.05430100408862887,
      "pct_mrgn_back": 0.25014582073485314,
      "pct_mrgn_total": 0.304446824823482,
      "pct_mrgn_total_prog": 0.03605056537121789,
      "pct_mrgn_net": 0.3219278291927193,
      "pct_mrgn_net_prog": 0.03776943456635416,
      "mo_sls_promo_share": 0.22876324448884044,
      "mo_sls_promo_share_prog": 0.1542218449884704
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "432",
      "vendor_name": "ООО СДС-ФУДС",
      "mo_sls": 17931618.94,
      "mo_sls_prog": -0.09303925275293852,
      "mo_sls_share": 0.01581823437280251,
      "qu_sls_itm": 90579,
      "qu_sls_itm_prog": -0.17575277770194644,
      "qu_sls_itm_share": 0.007019696597441741,
      "pct_mrgn_frnt": 0.12589971923639373,
      "pct_mrgn_back": 0.21381426645462723,
      "pct_mrgn_total": 0.33971398569102096,
      "pct_mrgn_total_prog": 0.10497586297601111,
      "pct_mrgn_net": 0.38864417866820705,
      "pct_mrgn_net_prog": 0.11977140821885537,
      "mo_sls_promo_share": 0.2002656487412508,
      "mo_sls_promo_share_prog": 0.16319633937079414
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "1727",
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_sls": 14904326.02,
      "mo_sls_prog": 0.20461772765851813,
      "mo_sls_share": 0.013147732111745336,
      "qu_sls_itm": 161899,
      "qu_sls_itm_prog": 0.10846450358421712,
      "qu_sls_itm_share": 0.012546858095466061,
      "pct_mrgn_frnt": 0.08313006024810507,
      "pct_mrgn_back": 0.15125857532738002,
      "pct_mrgn_total": 0.2343886355754851,
      "pct_mrgn_total_prog": -0.22046939428248635,
      "pct_mrgn_net": 0.25564000455605584,
      "pct_mrgn_net_prog": -0.2735338607314597,
      "mo_sls_promo_share": 0.11601522723534734,
      "mo_sls_promo_share_prog": 0.10482368125224358
    },
    {
      "noma_code": "TOTAL",
      "noma_name": "All nomenclature",
      "vendor_code": "7669",
      "vendor_name": "КМКК ЗАО 2",
      "mo_sls": 5568861.84,
      "mo_sls_prog": -0.03517435803839833,
      "mo_sls_share": 0.004912526976489287,
      "qu_sls_itm": 78785,
      "qu_sls_itm_prog": -0.05787742899850523,
      "qu_sls_itm_share": 0.0061056845011475906,
      "pct_mrgn_frnt": 0.051188605174661686,
      "pct_mrgn_back": 0.15715839881565458,
      "pct_mrgn_total": 0.20834700399031628,
      "pct_mrgn_total_prog": -0.005462422150349728,
      "pct_mrgn_net": 0.21958737545375892,
      "pct_mrgn_net_prog": -0.0033558961575390635,
      "mo_sls_promo_share": null,
      "mo_sls_promo_share_prog": 0
    }
  ],
  "Error": 0,
  "Msg": "",
  "Version": "1"
};
export const promo = {
  "report": [
    {
      "vendor_code": "9791",
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_sls": 201729288.69,
      "pct_mrgn_total": 0.160488848100543,
      "mo_sls_promo_share": 0.0022260641125348927
    },
    {
      "vendor_code": "730",
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_sls": 194894560.72,
      "pct_mrgn_total": 0.1642120365584721,
      "mo_sls_promo_share": null
    },
    {
      "vendor_code": "675",
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО",
      "mo_sls": 167032347.02,
      "pct_mrgn_total": 0.10121984460875476,
      "mo_sls_promo_share": 0.2440203338884988
    },
    {
      "vendor_code": "2514",
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_sls": 104595179.82,
      "pct_mrgn_total": 0.09385354991399832,
      "mo_sls_promo_share": 0.4013166107868163
    },
    {
      "vendor_code": "9839",
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_sls": 103581893.35,
      "pct_mrgn_total": 0.08236844707183565,
      "mo_sls_promo_share": 0.14579810555277903
    },
    {
      "vendor_code": "1154",
      "vendor_name": "Л'ОРЕАЛЬ ЗАО 2",
      "mo_sls": 103254258.34,
      "pct_mrgn_total": 0.12716420263040554,
      "mo_sls_promo_share": 0.1511231646119439
    },
    {
      "vendor_code": "208",
      "vendor_name": "ХЕНКЕЛЬ РУС ООО",
      "mo_sls": 81077941.52,
      "pct_mrgn_total": 0.101300008806637,
      "mo_sls_promo_share": 0.3835448295431761
    },
    {
      "vendor_code": "3147",
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_sls": 64753244.85,
      "pct_mrgn_total": 0.20634556400921428,
      "mo_sls_promo_share": 0.29555941797718266
    },
    {
      "vendor_code": "4153",
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_sls": 43542293.86,
      "pct_mrgn_total": 0.258516375048873,
      "mo_sls_promo_share": 0.061473019281120624
    },
    {
      "vendor_code": "14014",
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_sls": 30738512.63,
      "pct_mrgn_total": 0.304446824823482,
      "mo_sls_promo_share": 0.22876324448884044
    },
    {
      "vendor_code": "432",
      "vendor_name": "ООО СДС-ФУДС",
      "mo_sls": 17931618.94,
      "pct_mrgn_total": 0.33971398569102096,
      "mo_sls_promo_share": 0.2002656487412508
    },
    {
      "vendor_code": "1727",
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_sls": 14904326.02,
      "pct_mrgn_total": 0.2343886355754851,
      "mo_sls_promo_share": 0.11601522723534734
    },
    {
      "vendor_code": "7669",
      "vendor_name": "КМКК ЗАО 2",
      "mo_sls": 5568861.84,
      "pct_mrgn_total": 0.20834700399031628,
      "mo_sls_promo_share": null
    }
  ],
  "Error": 0,
  "Msg": "",
  "Version": "1"
};

export const avgPrice = {
  "report": [
    {
      "vendor_code": "9791",
      "nm_itm": "(213873) GM МОЛ.ПРОСТОКВ 3.4-4.5% 0.93Л",
      "mo_sls": 12706151.53,
      "itm_internal_code": "213873",
      "mo_avg_art_price": 61.49675255910752,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 1500149.72
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(235223) GM ПРО СМЕТАНА 20% 315Г",
      "mo_sls": 9770908.93,
      "itm_internal_code": "235223",
      "mo_avg_art_price": 69.92106116987019,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 1820393.71
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(774938) GM ПРО ТВОРОГ 5% ОБРАМ 220ГР",
      "mo_sls": 7052328.28,
      "itm_internal_code": "774938",
      "mo_avg_art_price": 81.5401759761357,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 1126526.26
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(716289) ЧАЙ GREENF. GOLDEN CEY 2ГX100П",
      "mo_sls": 6531605.48,
      "itm_internal_code": "716289",
      "mo_avg_art_price": 215.72116652354845,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 611181.82
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(235222) GM ПРО СМЕТАНА 15% 315Г",
      "mo_sls": 6045191.31,
      "itm_internal_code": "235222",
      "mo_avg_art_price": 60.85415909159545,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 1031978.05
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(12867) GILLETTE МАК 3 КАССЕТЫ 4 ШТУКИ",
      "mo_sls": 6025784.08,
      "itm_internal_code": "12867",
      "mo_avg_art_price": 732.2620099647588,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 435069.84
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(322401) GILLETTE FUSION КАС Д/СТ 4ШТ",
      "mo_sls": 5495332.61,
      "itm_internal_code": "322401",
      "mo_avg_art_price": 898.3705427497139,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 276621.88
    },
    {
      "vendor_code": "730",
      "nm_itm": "(666492) СМЕТАНА 15% 300Г ДОМИК В ДЕРЕВ",
      "mo_sls": 5418014.21,
      "itm_internal_code": "666492",
      "mo_avg_art_price": 60.47700819306157,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 1089036.93
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(155591) СМЕН КАСС Д/БР MACH3 8 ШТ",
      "mo_sls": 4622164.05,
      "itm_internal_code": "155591",
      "mo_avg_art_price": 1353.885193321617,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 499813.52
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(785113) КАСС.Д/БР 4ШТ FUSION PROGLIDE",
      "mo_sls": 4208710.75,
      "itm_internal_code": "785113",
      "mo_avg_art_price": 1149.9209699453552,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 435668.67
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(437700) GM ТВОРОГ ПРО КЛ. 2% ОБР.220ГР",
      "mo_sls": 4145828.94,
      "itm_internal_code": "437700",
      "mo_avg_art_price": 78.3340376003779,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 869792.65
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(919114) ПН GIL M3 БР+1К+ГД/Б_ЭКСКОМ 75",
      "mo_sls": 4067346.34,
      "itm_internal_code": "919114",
      "mo_avg_art_price": 177.3577961888981,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 124248
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(63309) GM ТВОР ЗЕРН 7% 350Г ПРО",
      "mo_sls": 4049525.56,
      "itm_internal_code": "63309",
      "mo_avg_art_price": 104.91542463340069,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 857015.5
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(322393) GILLETTE FUSION КАС Д/СТ 2ШТ",
      "mo_sls": 3980991.31,
      "itm_internal_code": "322393",
      "mo_avg_art_price": 565.2408504898481,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 473644.04
    },
    {
      "vendor_code": "730",
      "nm_itm": "(514701) GM МОЛОКО ПАСТ 3.7% 1400МЛ ДВД",
      "mo_sls": 3802808.93,
      "itm_internal_code": "514701",
      "mo_avg_art_price": 110.50822184121817,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 434987.51
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(12889) GILLETTE МАК3 КАССЕТЫ 2ШТ.",
      "mo_sls": 3733457.49,
      "itm_internal_code": "12889",
      "mo_avg_art_price": 435.64264760793463,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 456393.57
    },
    {
      "vendor_code": "730",
      "nm_itm": "(64551) GM КЕФИР 3.2% 1Л ДОМ В ДЕР.ТЕТ",
      "mo_sls": 3363959.25,
      "itm_internal_code": "64551",
      "mo_avg_art_price": 66.4998072589254,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": -9247.17
    },
    {
      "vendor_code": "208",
      "nm_itm": "(571303) ПНFA MENОХЛГ250+SCHAUMA Ш225ХМ",
      "mo_sls": 3296487.78,
      "itm_internal_code": "571303",
      "mo_avg_art_price": 185.26880121396056,
      "id_prty": 1,
      "vendor_name": "ХЕНКЕЛЬ РУС ООО",
      "mo_mrgn_total": 131321.28
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(232640) GM КЕФИР ПРОСТ.3.2% 0.93Л",
      "mo_sls": 3196462.25,
      "itm_internal_code": "232640",
      "mo_avg_art_price": 68.88481886946964,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 221185.66
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(284848) GM МОЛ ПАСТ.ПРОСТОК 2.5% 0.93Л",
      "mo_sls": 3166300.15,
      "itm_internal_code": "284848",
      "mo_avg_art_price": 70.40759934179805,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 281390.96
    },
    {
      "vendor_code": "730",
      "nm_itm": "(941148) GM ТВОРОГ ТРАД ДВД 9% 340Г",
      "mo_sls": 3102065.35,
      "itm_internal_code": "941148",
      "mo_avg_art_price": 140.6513420992972,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 776407.84
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(543488) КАСC Д/БР FUSION 8ШТ GILLETTE",
      "mo_sls": 2986222.37,
      "itm_internal_code": "543488",
      "mo_avg_art_price": 1710.3220904925545,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 270359.72
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(738562) ПРО СМЕТ ИЗ ТОПЛ СЛ 260 15%",
      "mo_sls": 2868187.64,
      "itm_internal_code": "738562",
      "mo_avg_art_price": 51.774209177226616,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 587214.13
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(826759) ЗЕЛ.GREEN MELISA 1,5Х100 GREENF",
      "mo_sls": 2851693.84,
      "itm_internal_code": "826759",
      "mo_avg_art_price": 214.9788043724086,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 551530.3
    },
    {
      "vendor_code": "208",
      "nm_itm": "(571176) ПНFAГЕЛЬУХОДСВЕЖ250+ГЕЛЬЭНЕРГИЯ250",
      "mo_sls": 2837806.37,
      "itm_internal_code": "571176",
      "mo_avg_art_price": 184.47678411233179,
      "id_prty": 1,
      "vendor_name": "ХЕНКЕЛЬ РУС ООО",
      "mo_mrgn_total": 85657.67
    },
    {
      "vendor_code": "432",
      "nm_itm": "(97647) ЭРЛ ГРЕЙ 100ПХ2Г ЧАЙ АХМАД ТИ",
      "mo_sls": 2634485.48,
      "itm_internal_code": "97647",
      "mo_avg_art_price": 284.47095130115537,
      "id_prty": 1,
      "vendor_name": "ООО СДС-ФУДС",
      "mo_mrgn_total": 693618.27
    },
    {
      "vendor_code": "208",
      "nm_itm": "(571220) ПНFAГЕЛЬНОЧИПАН250+МЫЛОБОДР90",
      "mo_sls": 2599815.65,
      "itm_internal_code": "571220",
      "mo_avg_art_price": 133.928273748197,
      "id_prty": 1,
      "vendor_name": "ХЕНКЕЛЬ РУС ООО",
      "mo_mrgn_total": -65062.04
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(571181) НАБОР\"УЛЬТРА\"NIVEA",
      "mo_sls": 2521484.76,
      "itm_internal_code": "571181",
      "mo_avg_art_price": 289.2606125960766,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 18388.08
    },
    {
      "vendor_code": "432",
      "nm_itm": "(10914) АНГЛ.ЗАВТ.ПАК100 ЧАЙ АХМАД ТИ",
      "mo_sls": 2516516.24,
      "itm_internal_code": "10914",
      "mo_avg_art_price": 282.02580298106017,
      "id_prty": 1,
      "vendor_name": "ООО СДС-ФУДС",
      "mo_mrgn_total": 639101.04
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22956) NIVEA ГЕЛЬ Д/БР.Д/ЧУВСТ.200МЛ",
      "mo_sls": 2497929.04,
      "itm_internal_code": "22956",
      "mo_avg_art_price": 227.72623210866988,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 218076.16
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(13069) GILLETT МАК 3 СТАНОК+2 КАССЕТЫ",
      "mo_sls": 2485877.09,
      "itm_internal_code": "13069",
      "mo_avg_art_price": 418.7092959407108,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 159324.36
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(96275) КОРОНА РОС.ИМП.ЧАЙ ЧЕРН.200Г",
      "mo_sls": 2473181.1,
      "itm_internal_code": "96275",
      "mo_avg_art_price": 131.25198216844453,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": -13118.35
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(309841) GILLETTE БРИТВА ОДНОР 10ШТ",
      "mo_sls": 2458817.85,
      "itm_internal_code": "309841",
      "mo_avg_art_price": 178.27855640951276,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 240465.24
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(13164) GILLETTE VENUS КАССЕТЫ ЖЕН.2ШТ",
      "mo_sls": 2450492.64,
      "itm_internal_code": "13164",
      "mo_avg_art_price": 399.4934202804043,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 146743.6
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(331770) GM ПРОСТОКВАШ. КЕФИР 2.5% 930Г",
      "mo_sls": 2435779.28,
      "itm_internal_code": "331770",
      "mo_avg_art_price": 67.59857019953931,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 134743.2
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(621292) КАС Д/БР FUS PROGL6ШТ GILLETTE",
      "mo_sls": 2428333.33,
      "itm_internal_code": "621292",
      "mo_avg_art_price": 1581.9761107491856,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 209058.63
    },
    {
      "vendor_code": "730",
      "nm_itm": "(584791) GM МОЛОКО ПАСТ ДВД ОТБОРН 930Г",
      "mo_sls": 2384833.7,
      "itm_internal_code": "584791",
      "mo_avg_art_price": 76.39290473444808,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 264429.48
    },
    {
      "vendor_code": "1727",
      "nm_itm": "(17925) LIPTON ЧЕРН БАЙХ YL 100 ПАК",
      "mo_sls": 2363733.27,
      "itm_internal_code": "17925",
      "mo_avg_art_price": 150.1831927060169,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_mrgn_total": 86191.83
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(571180) НАБОР\"ЗАРЯД ЧИСТОТЫ\"NIVEA",
      "mo_sls": 2327829.39,
      "itm_internal_code": "571180",
      "mo_avg_art_price": 269.9871711899791,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 34162.62
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(534666) GM СМЕТАНА 15% 315Г БРЕСТ ЛИТ.",
      "mo_sls": 2297017.03,
      "itm_internal_code": "534666",
      "mo_avg_art_price": 63.40621718607668,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 510605.57
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(235221) GM ПРО СМЕТАНА 10% 315Г",
      "mo_sls": 2217170.36,
      "itm_internal_code": "235221",
      "mo_avg_art_price": 52.5782057909839,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 283150.07
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(327920) GM ТВОРОГ ПРОСТОКВ КЛ. 9% 220Г",
      "mo_sls": 2208169.6,
      "itm_internal_code": "327920",
      "mo_avg_art_price": 105.54799483772287,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 312378.93
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(235229) GM ПРО СМЕТАНА 25% 315Г",
      "mo_sls": 2192817.84,
      "itm_internal_code": "235229",
      "mo_avg_art_price": 83.42151107053184,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 175214.17
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22837) НИВЕЯ БАЛЬЗАМ П/БР.Д/ЧУВС.100М",
      "mo_sls": 2156757.73,
      "itm_internal_code": "22837",
      "mo_avg_art_price": 288.3365949197861,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 185832.24
    },
    {
      "vendor_code": "1154",
      "nm_itm": "(571184) ФРУ ОГУРШМП250+ДЕОЗАЩ6 СПР",
      "mo_sls": 2141303.93,
      "itm_internal_code": "571184",
      "mo_avg_art_price": 231.0177937210055,
      "id_prty": 1,
      "vendor_name": "Л'ОРЕАЛЬ ЗАО 2",
      "mo_mrgn_total": 16039.04
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(571179) НАБОР\"УСПОКАИВАЮЩИЙ\"NIVEA",
      "mo_sls": 2128305.86,
      "itm_internal_code": "571179",
      "mo_avg_art_price": 419.7841932938856,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 47755.58
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(11999) GILLETTE REGUL ПЕНА Д/БР.Д/ЧУВ",
      "mo_sls": 2116159.22,
      "itm_internal_code": "11999",
      "mo_avg_art_price": 105.03073357157038,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 120923.07
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(12610) БРИТВЫ ОДНОРАЗ 2ШТ VENUS",
      "mo_sls": 2081480.13,
      "itm_internal_code": "12610",
      "mo_avg_art_price": 96.92573364377182,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 239965.2
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(52687) GM ТВОРОГ МЯГКИЙ 5% 170Г ДАНОН",
      "mo_sls": 2045079.4,
      "itm_internal_code": "52687",
      "mo_avg_art_price": 52.62414183521177,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 431179.31
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(428564) ТЕСС ПЛЭЖА ЧАЙ 1.5ГХ100 ПАК.",
      "mo_sls": 2039162.44,
      "itm_internal_code": "428564",
      "mo_avg_art_price": 201.39875950617284,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 1155987.06
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(387643) БРИТВА ОДНОРАЗ BLUE 4ШТ",
      "mo_sls": 2020520.34,
      "itm_internal_code": "387643",
      "mo_avg_art_price": 175.95753200383174,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 155856.42
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(13223) КАСС Д/БР 4ШТ VENUS",
      "mo_sls": 1985708.86,
      "itm_internal_code": "13223",
      "mo_avg_art_price": 658.8284207033842,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 178285.83
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(12530) GILLETTE ОДНОРАЗ.СТАН.J 5ШТ",
      "mo_sls": 1965047.03,
      "itm_internal_code": "12530",
      "mo_avg_art_price": 100.09408262021189,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 131422.1
    },
    {
      "vendor_code": "1154",
      "nm_itm": "(989658) МИЦ ВОДА 3В1 Д/Ч 400МЛ ГАРНЬЕ",
      "mo_sls": 1935371.1,
      "itm_internal_code": "989658",
      "mo_avg_art_price": 229.41810099573257,
      "id_prty": 1,
      "vendor_name": "Л'ОРЕАЛЬ ЗАО 2",
      "mo_mrgn_total": 228837.96
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(826760) ЧЕР.БЕРГ.EARL GREY 2ГХ100П GREEN",
      "mo_sls": 1905816.38,
      "itm_internal_code": "826760",
      "mo_avg_art_price": 270.90495806680883,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 45405.77
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(571305) НАБОР\"КАРБОН\"NIVEA",
      "mo_sls": 1865429.35,
      "itm_internal_code": "571305",
      "mo_avg_art_price": 246.42395640686922,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 22582.03
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(547037) SРОМО BLUEII ОДН СТ Д/Ж 5 ШТ",
      "mo_sls": 1847341.8,
      "itm_internal_code": "547037",
      "mo_avg_art_price": 118.37381776239907,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 228376
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(322413) GILLETTE FUSION СТАНОК Д/БР",
      "mo_sls": 1842717.82,
      "itm_internal_code": "322413",
      "mo_avg_art_price": 607.1557891268534,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 186763.99
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(324520) GM ТВОРОГ САВ. ХУТОРОК 9% 300Г",
      "mo_sls": 1831605.27,
      "itm_internal_code": "324520",
      "mo_avg_art_price": 114.9062277289837,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 433986.76
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(571248) ПНGIL M3STБРСМК+ПБР ЧУВК 100МЛ",
      "mo_sls": 1813767,
      "itm_internal_code": "571248",
      "mo_avg_art_price": 371.293142272262,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": -12408.34
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(294783) ЧАЙ ЧЕРН 100ПАК CEYLON RICHARD",
      "mo_sls": 1788643.92,
      "itm_internal_code": "294783",
      "mo_avg_art_price": 200.76820294084632,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 935308.2
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(63304) GM ТВОР ЗЕРН 7% 130Г ПРО",
      "mo_sls": 1758495.59,
      "itm_internal_code": "63304",
      "mo_avg_art_price": 60.77189625380149,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 296336.37
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(283940) БР FUSPR FLBALL+2 СМ КАС GIL",
      "mo_sls": 1756634.95,
      "itm_internal_code": "283940",
      "mo_avg_art_price": 726.1822860686234,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 226898.93
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(632184) СМЕТАНА 20% 315Г БРЕСТ-ЛИТОВСК",
      "mo_sls": 1756035.68,
      "itm_internal_code": "632184",
      "mo_avg_art_price": 77.61826732673268,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 397647.13
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(540023) КАСС MACH3 START 8ШТ GILLETTE",
      "mo_sls": 1743909.93,
      "itm_internal_code": "540023",
      "mo_avg_art_price": 1276.6544143484628,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 112056.66
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(37818) ГЕЛЬ Д/БР ЗАЩ И УХОД 200 NIVEA",
      "mo_sls": 1739295.5,
      "itm_internal_code": "37818",
      "mo_avg_art_price": 226.94356732776617,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 138249.35
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(294808) ЧАЙ ЧЕРН 25 ПАК CEYLON RICHARD",
      "mo_sls": 1735116.68,
      "itm_internal_code": "294808",
      "mo_avg_art_price": 65.55030902908953,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": -5319.84
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(785135) СТАН.ОДНОР.4ШТ GILL BLUEII MAX",
      "mo_sls": 1725644.76,
      "itm_internal_code": "785135",
      "mo_avg_art_price": 173.67600241545892,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 103524.37
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(883656) ЧАЙ RICHARD LORD GREY 2ГX25",
      "mo_sls": 1708432.33,
      "itm_internal_code": "883656",
      "mo_avg_art_price": 65.81018220338983,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": -31169
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(866270) ЧАЙ ЗЕЛ.TESS LIME 1.5Х100 ПАК",
      "mo_sls": 1692131.61,
      "itm_internal_code": "866270",
      "mo_avg_art_price": 198.5603860596104,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 710103.18
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(64762) КАСС MACH3TURBО 4ШТ GILLETTE",
      "mo_sls": 1681508.78,
      "itm_internal_code": "64762",
      "mo_avg_art_price": 844.5548869914616,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 140279.79
    },
    {
      "vendor_code": "730",
      "nm_itm": "(666761) СМЕТАНА 20% 300Г ДОМИК В ДЕРЕВ",
      "mo_sls": 1677852.37,
      "itm_internal_code": "666761",
      "mo_avg_art_price": 76.61426347031963,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 317769.19
    },
    {
      "vendor_code": "675",
      "nm_itm": "(571183) AXE ПН АЙС ЧИЛЛ,(150+250)МЛ",
      "mo_sls": 1659431.1,
      "itm_internal_code": "571183",
      "mo_avg_art_price": 413.1020911127707,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО",
      "mo_mrgn_total": 80663.81
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(330336) ТВОРОГ НЕЖНЫЙ 5% 125Г",
      "mo_sls": 1623879.31,
      "itm_internal_code": "330336",
      "mo_avg_art_price": 33.126872909016726,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 429169
    },
    {
      "vendor_code": "1727",
      "nm_itm": "(448050) ЧАЙ ЛИПТОН ENG.BREAKFAST100ПХ2",
      "mo_sls": 1521568.96,
      "itm_internal_code": "448050",
      "mo_avg_art_price": 151.05420033753597,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_mrgn_total": 55394.76
    },
    {
      "vendor_code": "730",
      "nm_itm": "(35437) GM ТВОР МЯГКИЙ5.5%170ГДОМИК В Д",
      "mo_sls": 1518754.87,
      "itm_internal_code": "35437",
      "mo_avg_art_price": 46.81879435247696,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 400255.86
    },
    {
      "vendor_code": "432",
      "nm_itm": "(258226) ЧЕРН.ЭРЛГРЕЙ200Г ЧАЙ АХМАД ТИ",
      "mo_sls": 1493683.03,
      "itm_internal_code": "258226",
      "mo_avg_art_price": 257.79824473593374,
      "id_prty": 1,
      "vendor_name": "ООО СДС-ФУДС",
      "mo_mrgn_total": 698089.62
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(61699) ЧАЙ ЧЕРН 200Г ГРИНФ ГОЛДЕН ЦЕЙЛОН",
      "mo_sls": 1450573.05,
      "itm_internal_code": "61699",
      "mo_avg_art_price": 184.78637579617833,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 159660.99
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(488243) GM ПРОСТОКВ. СМЕТАНА 15% 180ГР",
      "mo_sls": 1445897.51,
      "itm_internal_code": "488243",
      "mo_avg_art_price": 42.7236802292941,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 203234.65
    },
    {
      "vendor_code": "730",
      "nm_itm": "(532252) МОЛОКО ПАСТ 2.5% 1.4Л ДВД",
      "mo_sls": 1437570.77,
      "itm_internal_code": "532252",
      "mo_avg_art_price": 104.5201955794678,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 155260.09
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(155594) СТАНОК FUSION FLEXBALL POW+1 К",
      "mo_sls": 1428460.26,
      "itm_internal_code": "155594",
      "mo_avg_art_price": 875.2820220588235,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 120481.76
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(518324) ЧАЙ RICHARD EARL GREY 100ПАК",
      "mo_sls": 1424004.73,
      "itm_internal_code": "518324",
      "mo_avg_art_price": 199.13364983918333,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 716130.58
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22821) НИВЕЯ ЛОС.П/БР.Д/ЧУВСТВ.100МЛ",
      "mo_sls": 1423921.51,
      "itm_internal_code": "22821",
      "mo_avg_art_price": 288.3015812917595,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 130998.23
    },
    {
      "vendor_code": "675",
      "nm_itm": "(571177) TIMOTEIMEN ПН ПРОХ,(400+250)МЛ",
      "mo_sls": 1406027.85,
      "itm_internal_code": "571177",
      "mo_avg_art_price": 274.614814453125,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО",
      "mo_mrgn_total": 25472.64
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(571261) ПН GБСМК+П/ЧК100МЛ+HSШОУ90МЛ+К",
      "mo_sls": 1404741.03,
      "itm_internal_code": "571261",
      "mo_avg_art_price": 582.3967786069652,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": -23404.38
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(399736) GM МОЛОКО 3.6% 1Л ПЭТ БРЕСТ Л.",
      "mo_sls": 1388232.22,
      "itm_internal_code": "399736",
      "mo_avg_art_price": 73.68536199575371,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 233096.1
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(535945) ПН GILM3БРСМКАС+HSШ ОУХ 200МЛ",
      "mo_sls": 1388006.94,
      "itm_internal_code": "535945",
      "mo_avg_art_price": 450.9444249512671,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": -53838.91
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(655039) ГЕЛЬ Д/БРИТЬЯ ULTRA 200 NIVEA",
      "mo_sls": 1367070.84,
      "itm_internal_code": "655039",
      "mo_avg_art_price": 227.76921692769076,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 134145.27
    },
    {
      "vendor_code": "1727",
      "nm_itm": "(961609) LIPTON EARL GREY 100 ПАК",
      "mo_sls": 1365249.36,
      "itm_internal_code": "961609",
      "mo_avg_art_price": 151.49238348868175,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_mrgn_total": 78930.64
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(11935) GILLETTE ПЕНА Д/БР ЛИМОН200МЛ",
      "mo_sls": 1359279.27,
      "itm_internal_code": "11935",
      "mo_avg_art_price": 105.05288430326918,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 150761.57
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(538675) ЧАЙ ПРИНЦ НУРИ ВЫСОКОГОР 100П 200Г",
      "mo_sls": 1318447.96,
      "itm_internal_code": "538675",
      "mo_avg_art_price": 137.29542434655838,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 175430.65
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(296565) ГЕЛЬ Д/БР ВОССТАНАВЛ 200 NIVEA",
      "mo_sls": 1311316.48,
      "itm_internal_code": "296565",
      "mo_avg_art_price": 227.97574408901252,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 137504.08
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(155593) СТАНОК FUS PROGL FLEXBALL С 1К",
      "mo_sls": 1289554.49,
      "itm_internal_code": "155593",
      "mo_avg_art_price": 587.2288205828779,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 145578.37
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(422219) GIL TGS ПЕНАД/Б Д/ЧУВС КОЖ 250",
      "mo_sls": 1279761.7,
      "itm_internal_code": "422219",
      "mo_avg_art_price": 149.81991336923437,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 93106.91
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(46766) GM ТВОРОГ НЕЖНЫЙ 0% 125Г",
      "mo_sls": 1269698.34,
      "itm_internal_code": "46766",
      "mo_avg_art_price": 32.95521023671096,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 335138.05
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(41045) ПРИНЦЕССА НУРИ ЧАЙ ПАК.100Х2Г",
      "mo_sls": 1264344.68,
      "itm_internal_code": "41045",
      "mo_avg_art_price": 136.12668819982773,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 207167.31
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(322410) GILLETE FUSION POW КАС Д/СТ 4ШТ",
      "mo_sls": 1252173.76,
      "itm_internal_code": "322410",
      "mo_avg_art_price": 1099.3623880597015,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 148640.56
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(96050) ЛИСМА ЧАЙ ЧЕРН КРЕПК 100ПХ2Г",
      "mo_sls": 1239208.35,
      "itm_internal_code": "96050",
      "mo_avg_art_price": 125.92301087287878,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 230068.2
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(796321) GM СМЕТАНА 20% 180Г БРЕСТ-ЛИТ.",
      "mo_sls": 1238452.32,
      "itm_internal_code": "796321",
      "mo_avg_art_price": 48.11205159084729,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 280777.92
    },
    {
      "vendor_code": "1154",
      "nm_itm": "(571178) МЕ ПЕНА ДО+КРЕМ ПОСЛЕ СЕН",
      "mo_sls": 1228243.68,
      "itm_internal_code": "571178",
      "mo_avg_art_price": 427.36384133611693,
      "id_prty": 1,
      "vendor_name": "Л'ОРЕАЛЬ ЗАО 2",
      "mo_mrgn_total": -14917.09
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(540030) КАСС MACH3 START 4ШТ GILLETTE",
      "mo_sls": 1218673.72,
      "itm_internal_code": "540030",
      "mo_avg_art_price": 788.2753686934024,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 153960.62
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22940) NIVEA ПЕНА Д/БР.Д/ЧУВСТВ.200М",
      "mo_sls": 1218468.16,
      "itm_internal_code": "22940",
      "mo_avg_art_price": 162.00879670256614,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 205134.52
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(34338) БАЛЬ П/БР ЗАЩ И УХОД 100 NIVEA",
      "mo_sls": 1209770.96,
      "itm_internal_code": "34338",
      "mo_avg_art_price": 285.9302670763413,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 133576.66
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(111761) GREENF\"GOLD CEYL\"ЧАЙ ЧЕР 100Г",
      "mo_sls": 1201896.91,
      "itm_internal_code": "111761",
      "mo_avg_art_price": 99.6515139706492,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 326854.07
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(483433) GM МОЛ ТОПЛ. ПРО 3.2%0.93Л ПЭТ",
      "mo_sls": 1188276.71,
      "itm_internal_code": "483433",
      "mo_avg_art_price": 78.41857783937174,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 153146.59
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(547040) BLUE II PLUS ОДНОР СТ SEN 5ШТ",
      "mo_sls": 1187298.25,
      "itm_internal_code": "547040",
      "mo_avg_art_price": 183.87769087811677,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 130978.92
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(351678) БАЛЬЗ П/БР ВОССТАН 100 NIVEA",
      "mo_sls": 1167516.39,
      "itm_internal_code": "351678",
      "mo_avg_art_price": 285.1077875457876,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 106136.11
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22219) НИВЕЯ КРЕМ СОФТ 200 МЛ",
      "mo_sls": 1145797.8,
      "itm_internal_code": "22219",
      "mo_avg_art_price": 262.91826525929326,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 107766.71
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(425736) СМЕТАНА 26% 315ГР БРЕСТ ЛИТ",
      "mo_sls": 1127192.59,
      "itm_internal_code": "425736",
      "mo_avg_art_price": 94.12095774883099,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 307462.47
    },
    {
      "vendor_code": "730",
      "nm_itm": "(36740) GM РЯЖЕНКА 3.2% ДВД 950Г",
      "mo_sls": 1119503.69,
      "itm_internal_code": "36740",
      "mo_avg_art_price": 83.25923620407556,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 103470.01
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(108186) GILLETTE2 ОДНОР СТАН DIS3 FXD",
      "mo_sls": 1092373.73,
      "itm_internal_code": "108186",
      "mo_avg_art_price": 75.47144742296531,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 152213.27
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(213892) GM КЕФ.ПРОД.БИО-БАЛ.1% 0.93Л",
      "mo_sls": 1088735.82,
      "itm_internal_code": "213892",
      "mo_avg_art_price": 76.28474075112108,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 171190.68
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(774905) GM ПРО КЕФИР 1% ПЭТ 930Г",
      "mo_sls": 1086955.62,
      "itm_internal_code": "774905",
      "mo_avg_art_price": 66.14871105160663,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 109075.26
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(650119) ЛОС. П/БРИТЬЯ ULTRA 100 NIVEA",
      "mo_sls": 1080384.77,
      "itm_internal_code": "650119",
      "mo_avg_art_price": 287.6423775292865,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 133791.87
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(830447) SIMPLY VENUS БРИТВЫ ОДНОР.4ШТ",
      "mo_sls": 1071693.66,
      "itm_internal_code": "830447",
      "mo_avg_art_price": 223.8758429078755,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 58812.89
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(578095) ЧАЙ RICHARD ENGL BREAKF 100ПАК",
      "mo_sls": 1061943.89,
      "itm_internal_code": "578095",
      "mo_avg_art_price": 206.6842915531335,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 522450.5
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(394086) ЧАЙ РИЧАРД РОЯЛ МЕЛИССА 25ПХ2Г",
      "mo_sls": 1056774.47,
      "itm_internal_code": "394086",
      "mo_avg_art_price": 65.90012908455974,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": -753.73
    },
    {
      "vendor_code": "675",
      "nm_itm": "(144232) БАРХ.РУЧКИ КР.ПИТАТЕЛЬН.80/100",
      "mo_sls": 1045787.13,
      "itm_internal_code": "144232",
      "mo_avg_art_price": 53.72930178791615,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО",
      "mo_mrgn_total": 130185.21
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(491863) TESS PLEASURE 1,5X25",
      "mo_sls": 1045653.33,
      "itm_internal_code": "491863",
      "mo_avg_art_price": 69.23022576800848,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 192788.13
    },
    {
      "vendor_code": "432",
      "nm_itm": "(258251) ЧЕРН.КЛАСС.200Г ЧАЙ АХМАД ТИ",
      "mo_sls": 1034942.02,
      "itm_internal_code": "258251",
      "mo_avg_art_price": 188.03452398255814,
      "id_prty": 1,
      "vendor_name": "ООО СДС-ФУДС",
      "mo_mrgn_total": 288431.93
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(399737) ТВОРОГ 5% 300Г САВ ХУТОРОК",
      "mo_sls": 1034701.52,
      "itm_internal_code": "399737",
      "mo_avg_art_price": 111.76296392309354,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 277508.47
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(987706) НИВЕЯ ГЕЛЬ Д/БР.ОХЛАЖД.200МЛ",
      "mo_sls": 1034084.48,
      "itm_internal_code": "987706",
      "mo_avg_art_price": 226.3262158021449,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 123596.88
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(149003) КАССЕТЫ VENUS DIVINE 4ШТ",
      "mo_sls": 1024763.46,
      "itm_internal_code": "149003",
      "mo_avg_art_price": 668.9056527415144,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 101378.74
    },
    {
      "vendor_code": "7669",
      "nm_itm": "(618044) СМЕТАНА ФАС.20% ПЛ.0,45КГ",
      "mo_sls": 1020106.59,
      "itm_internal_code": "618044",
      "mo_avg_art_price": 71.37605583543241,
      "id_prty": 1,
      "vendor_name": "КМКК ЗАО 2",
      "mo_mrgn_total": 177722.13
    },
    {
      "vendor_code": "7669",
      "nm_itm": "(538694) ТВОРОГ 9%, 340Г, ПАКЕТ КИЗК",
      "mo_sls": 1013380.84,
      "itm_internal_code": "538694",
      "mo_avg_art_price": 135.20758372248164,
      "id_prty": 1,
      "vendor_name": "КМКК ЗАО 2",
      "mo_mrgn_total": 214221.76
    },
    {
      "vendor_code": "730",
      "nm_itm": "(637760) GM МОЛОКО ПАСТ.ДВД 2.5% 930Г",
      "mo_sls": 1013062.3,
      "itm_internal_code": "637760",
      "mo_avg_art_price": 71.53889555822329,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 102817.38
    },
    {
      "vendor_code": "730",
      "nm_itm": "(651509) GM ПАСТ.МОЛОКО ВЕС.МОЛ ОТБ 930",
      "mo_sls": 1005943.07,
      "itm_internal_code": "651509",
      "mo_avg_art_price": 68.67443132168214,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 80663.65
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(215304) ЧАЙ RICHARD ROYAL GREEN 25ПАК",
      "mo_sls": 999937.89,
      "itm_internal_code": "215304",
      "mo_avg_art_price": 66.0504584186538,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": -2836.81
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(791894) ПРО ТВОРОГ 180 9% ТРАДИЦИОННЫЙ",
      "mo_sls": 995817.89,
      "itm_internal_code": "791894",
      "mo_avg_art_price": 84.95289967582323,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 248675.33
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(157215) ГЕЛЬ Д/БР 3ХДНЕВН ЩЕТ200 NIVEA",
      "mo_sls": 994795.7,
      "itm_internal_code": "157215",
      "mo_avg_art_price": 226.6565732513101,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 68556.78
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(487235) GILLETTE КАРТР VENUS EMBRAS2ШТ",
      "mo_sls": 983915.92,
      "itm_internal_code": "487235",
      "mo_avg_art_price": 605.8595566502463,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 113722.7
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(111760) GREENF\"GOLD CEYL\"ЧАЙ ЧЕР 25Х2",
      "mo_sls": 976756.99,
      "itm_internal_code": "111760",
      "mo_avg_art_price": 90.64188845582777,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 226138.48
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(987708) НИВЕЯ БАЛЬЗАМ ОХЛАЖД.100МЛ",
      "mo_sls": 964851.68,
      "itm_internal_code": "987708",
      "mo_avg_art_price": 289.1374528019179,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 110315.97
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(322406) GILLETE FUSION POWER КАС Д/СТ2ШТ",
      "mo_sls": 958230.31,
      "itm_internal_code": "322406",
      "mo_avg_art_price": 677.673486562942,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 124521.7
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(382331) ЛОС П/БР 2В1 ЗАЩ И УХ 100NIVEA",
      "mo_sls": 956846.93,
      "itm_internal_code": "382331",
      "mo_avg_art_price": 287.9467138128197,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 73893.81
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22859) КР-БАЛ П/БР ЗАЩ И УХ 75 NIVEA",
      "mo_sls": 939784.21,
      "itm_internal_code": "22859",
      "mo_avg_art_price": 219.78115294667913,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 98629.58
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(945647) КРЕМ Д/РУК КОМПЛ УХОД 75 NIVEA",
      "mo_sls": 938141.36,
      "itm_internal_code": "945647",
      "mo_avg_art_price": 59.16260074415085,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 64021.02
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(491868) GREENF.SPRING MELODY 1,5X25",
      "mo_sls": 933422.56,
      "itm_internal_code": "491868",
      "mo_avg_art_price": 81.23075102253938,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 94675.44
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(737391) ПРО ТВ МЯГК 5% 130",
      "mo_sls": 925948.77,
      "itm_internal_code": "737391",
      "mo_avg_art_price": 37.75376212998451,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 189867.47
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(966788) ЧАЙ RICHARD THYME&ROSE100ПАК",
      "mo_sls": 917331.9,
      "itm_internal_code": "966788",
      "mo_avg_art_price": 195.13548181238033,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 403160.1
    },
    {
      "vendor_code": "730",
      "nm_itm": "(499723) МОЛОКО ПАСТ 2.5%1400МЛ КБ",
      "mo_sls": 907237.74,
      "itm_internal_code": "499723",
      "mo_avg_art_price": 97.89983166073164,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 21630.64
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(531359) ЧАЙ RICHARD CEYLON 180ГР",
      "mo_sls": 906906.55,
      "itm_internal_code": "531359",
      "mo_avg_art_price": 204.9969597649186,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 547374.98
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22970) ЛОСЬОН П/БР ЭКС.СВЕЖ 100 НИВЕЯ",
      "mo_sls": 902945.99,
      "itm_internal_code": "22970",
      "mo_avg_art_price": 286.10455956907475,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 102349.89
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(945646) КРЕМ Д/РУК УВЛ И СМЯГ 75 NIVEA",
      "mo_sls": 896223.45,
      "itm_internal_code": "945646",
      "mo_avg_art_price": 59.11374249719675,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 48479.94
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(535955) ПН GI FБРСМК+ЧЕХ+ГДБРFЧК 75МЛ",
      "mo_sls": 895127.11,
      "itm_internal_code": "535955",
      "mo_avg_art_price": 710.9826131850675,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 35536.21
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(159387) GM ТВОРОГ МЯГК 0% 170Г ДАНОН",
      "mo_sls": 889041.51,
      "itm_internal_code": "159387",
      "mo_avg_art_price": 48.78678099105526,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 195240.32
    },
    {
      "vendor_code": "730",
      "nm_itm": "(165002) ТВОРОГ ДВД 9% 170Г",
      "mo_sls": 875084.56,
      "itm_internal_code": "165002",
      "mo_avg_art_price": 86.83978961992656,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 233360.01
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(651312) MACH3 БРИТВА С 1 СМЕН.КАССЕТОЙ",
      "mo_sls": 856681.16,
      "itm_internal_code": "651312",
      "mo_avg_art_price": 336.4812097407698,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 61009.04
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(532239) К/М ПРОД ПРОБИОТ 1% 930Г БИОБ",
      "mo_sls": 856241.68,
      "itm_internal_code": "532239",
      "mo_avg_art_price": 75.85415308291992,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 130222.77
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22733) НИВЕЯ КРЕМ ДЛЯ КОЖИ 250 МЛ",
      "mo_sls": 855766.14,
      "itm_internal_code": "22733",
      "mo_avg_art_price": 250.51701990632318,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 118209.78
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(253964) СМЕТАНА ДЕС КЛУБ 260Г 13% ПРО",
      "mo_sls": 847889.65,
      "itm_internal_code": "253964",
      "mo_avg_art_price": 56.20001657055743,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 195217.45
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(313058) ПЕНА Д/БР.ПИТ/ТОН.МАСЛ.КАКАО 250МЛ",
      "mo_sls": 827918.13,
      "itm_internal_code": "313058",
      "mo_avg_art_price": 149.7410255018991,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 59280.06
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22781) НИВЕЯ КРЕМ ДЛЯ КОЖИ 150 МЛ",
      "mo_sls": 818712.04,
      "itm_internal_code": "22781",
      "mo_avg_art_price": 178.87525453353726,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 81673.91
    },
    {
      "vendor_code": "432",
      "nm_itm": "(258245) ЧЕРН.ОР.ПЕКО200Г ЧАЙ АХМАД ТИ",
      "mo_sls": 816066.65,
      "itm_internal_code": "258245",
      "mo_avg_art_price": 258.3306900918012,
      "id_prty": 1,
      "vendor_name": "ООО СДС-ФУДС",
      "mo_mrgn_total": 455052.3
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(432236) ГЕЛЬ Д/БР ЧИСТ. КОЖ  NIVEA 200",
      "mo_sls": 815334.97,
      "itm_internal_code": "432236",
      "mo_avg_art_price": 223.19599507254313,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 70923.44
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(290664) НИВЕЯ КРЕМ СОФТ 100МЛ",
      "mo_sls": 805111.39,
      "itm_internal_code": "290664",
      "mo_avg_art_price": 155.63722984728398,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 70527.68
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(357343) TESS PLEASURE ЧАЙ ЧЕРНЫЙ 100Г",
      "mo_sls": 804442.91,
      "itm_internal_code": "357343",
      "mo_avg_art_price": 87.0420807184592,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 250527.7
    },
    {
      "vendor_code": "730",
      "nm_itm": "(673490) СМЕТАНА 15% 300Г КУБАНСКАЯ БУР",
      "mo_sls": 803965.01,
      "itm_internal_code": "673490",
      "mo_avg_art_price": 55.9630384240568,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 113024.49
    },
    {
      "vendor_code": "675",
      "nm_itm": "(578142) CAMAY ПОДАРОЧНЫЙ НАБОР ROMANTIQUE19",
      "mo_sls": 803866.6,
      "itm_internal_code": "578142",
      "mo_avg_art_price": 228.6960455192034,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО",
      "mo_mrgn_total": 48452.27
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(215332) GREENFIELD GREEN MELISSA 25Х1,5ГР",
      "mo_sls": 796025.84,
      "itm_internal_code": "215332",
      "mo_avg_art_price": 84.28013128639492,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 91610.69
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(99074) МАЙ ЧАЙ ЧЕР КОР РОС ИМП 100Х2Г",
      "mo_sls": 795250.77,
      "itm_internal_code": "99074",
      "mo_avg_art_price": 147.59665367483296,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 89503.78
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(265856) ТВОРРАСС 250Г 9% ПАКЕТ ПРО",
      "mo_sls": 794537.18,
      "itm_internal_code": "265856",
      "mo_avg_art_price": 98.22440103844727,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 175427.27
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(63092) GILLETTE ГЕЛЬ Д/БР.Д/ЧУВ.КОЖ200МЛ",
      "mo_sls": 793965.44,
      "itm_internal_code": "63092",
      "mo_avg_art_price": 253.8252685421995,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 30756.51
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(491861) GREENFIELD EARL GREY 2X25",
      "mo_sls": 788990.8,
      "itm_internal_code": "491861",
      "mo_avg_art_price": 88.38252492438669,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 125934.08
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(488241) GM ПРО СМЕТАНА 20% 180ГР СТАК",
      "mo_sls": 780789.81,
      "itm_internal_code": "488241",
      "mo_avg_art_price": 48.12560465976331,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 116514.24
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(296223) Н-Р ЧАЙ.НАП.30 ПАК 212,4Г ГРИНФ.",
      "mo_sls": 778656.98,
      "itm_internal_code": "296223",
      "mo_avg_art_price": 358.0032091954023,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 282831.68
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(269723) СМЕТАНА БРЕСТЛИТ 15%180Г",
      "mo_sls": 770795.35,
      "itm_internal_code": "269723",
      "mo_avg_art_price": 43.50843023255814,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 223971.02
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(418361) ЧАЙ ТЕСС ФЛИРТ 25 ПАКХ1.5Г",
      "mo_sls": 768467.9,
      "itm_internal_code": "418361",
      "mo_avg_art_price": 64.81679318488528,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 133557.65
    },
    {
      "vendor_code": "730",
      "nm_itm": "(36783) GM КЕФИР 3.2% 500Г ДОМИК В ДЕР",
      "mo_sls": 752973.87,
      "itm_internal_code": "36783",
      "mo_avg_art_price": 49.466158849034294,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 121363.66
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(111771) GREENF\"CLAS BREAK\"ЧАЙ ЧЕР25Х2Г",
      "mo_sls": 745445.27,
      "itm_internal_code": "111771",
      "mo_avg_art_price": 78.56716589376055,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 61353.89
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(75266) GM ТВОР ЗЕРН КЛУБ 7% 150Г ПРО",
      "mo_sls": 745077.57,
      "itm_internal_code": "75266",
      "mo_avg_art_price": 65.7150793790792,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 142931.54
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(479301) GM ПРО РЯЖЕНКА 3.2% 930Г ПЭТ",
      "mo_sls": 743187.9,
      "itm_internal_code": "479301",
      "mo_avg_art_price": 85.00376301040832,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 151400.13
    },
    {
      "vendor_code": "1727",
      "nm_itm": "(17878) LIPTON YL ЧАЙ ЧЕРН 25ПАКХ2Г",
      "mo_sls": 736763.57,
      "itm_internal_code": "17878",
      "mo_avg_art_price": 47.66228296027947,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_mrgn_total": 131021.77
    },
    {
      "vendor_code": "730",
      "nm_itm": "(36953) GM КЕФИР 1% ДВД 1Л",
      "mo_sls": 735627.42,
      "itm_internal_code": "36953",
      "mo_avg_art_price": 67.65012139047269,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 122528.59
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(154622) GM ПАСТ МОЛОКО 1.5% 930Г ПРО",
      "mo_sls": 734770.94,
      "itm_internal_code": "154622",
      "mo_avg_art_price": 67.82709683374873,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 120489.51
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(357403) GILLETTE VENUS BR КАС Д/СТ2ШТ",
      "mo_sls": 732356.67,
      "itm_internal_code": "357403",
      "mo_avg_art_price": 528.8369448111123,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 92754.31
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(487234) КАСС Д/БР 4ШТ VENUS EMBRACE",
      "mo_sls": 730302.69,
      "itm_internal_code": "487234",
      "mo_avg_art_price": 941.1117139175258,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 84165.79
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(521194) GILLETTE VENUS СТ Д/Б ЖЕН",
      "mo_sls": 730074,
      "itm_internal_code": "521194",
      "mo_avg_art_price": 336.4396313364055,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 52688.19
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(399967) ЧАЙ ЧЕРН МАЙСКИЙ ВЫСОК 100П",
      "mo_sls": 728093.89,
      "itm_internal_code": "399967",
      "mo_avg_art_price": 143.0439862475442,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 90829.07
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(484017) БИО-БАЛАНС КЕФИР 0% 930Г ПЭТ",
      "mo_sls": 726749.25,
      "itm_internal_code": "484017",
      "mo_avg_art_price": 76.09143021673123,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 138183.17
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(571260) ПН GIL FБРСМКАС+ГБРFUS ЧК 75МЛ",
      "mo_sls": 724716.28,
      "itm_internal_code": "571260",
      "mo_avg_art_price": 643.6201420959147,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 16243.49
    },
    {
      "vendor_code": "7669",
      "nm_itm": "(300037) ТВОРОГ 0% Ф/П 180Г КИЗК",
      "mo_sls": 722739.54,
      "itm_internal_code": "300037",
      "mo_avg_art_price": 57.38760838494521,
      "id_prty": 1,
      "vendor_name": "КМКК ЗАО 2",
      "mo_mrgn_total": 170224.22
    },
    {
      "vendor_code": "730",
      "nm_itm": "(666936) СМЕТАНА 25% 300Г ДОМИК В ДЕРЕВ",
      "mo_sls": 722093.49,
      "itm_internal_code": "666936",
      "mo_avg_art_price": 81.18883404542387,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 89926.81
    },
    {
      "vendor_code": "730",
      "nm_itm": "(35374) GM ТВОР МЯГКИЙ0.1%170ГДОМИК В Д",
      "mo_sls": 718872.65,
      "itm_internal_code": "35374",
      "mo_avg_art_price": 46.77724167100469,
      "id_prty": 1,
      "vendor_name": "\"ВИММ-БИЛЛЬ-ДАНН\"АО",
      "mo_mrgn_total": 144184.09
    },
    {
      "vendor_code": "1727",
      "nm_itm": "(961597) LIPTON ROYAL CEYLON 25 ПАК",
      "mo_sls": 716618.41,
      "itm_internal_code": "961597",
      "mo_avg_art_price": 47.077809092103536,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_mrgn_total": 105729.73
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(851634) ЧАЙ ЧЕРН 100ПАК TESS SUNRISE",
      "mo_sls": 714357.6,
      "itm_internal_code": "851634",
      "mo_avg_art_price": 252.2449152542373,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 829224.93
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(892223) КРЕМ Д/РУК ПИТ И КРАС 75 NIVEA",
      "mo_sls": 713288.55,
      "itm_internal_code": "892223",
      "mo_avg_art_price": 59.25800033230872,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 44316.65
    },
    {
      "vendor_code": "3147",
      "nm_itm": "(85260) ПРИНЦЕС.ЯВА ЧАЙ ЗЕЛЕН.БЕСТ 100",
      "mo_sls": 713070.1,
      "itm_internal_code": "85260",
      "mo_avg_art_price": 62.21166463095446,
      "id_prty": 1,
      "vendor_name": "ОРИМИ ТРЭЙД ООО",
      "mo_mrgn_total": 207512.92
    },
    {
      "vendor_code": "208",
      "nm_itm": "(577975) ПНFAГЕЛЬБАЛИ250+ЖИД+КМЫЛО",
      "mo_sls": 710635.2,
      "itm_internal_code": "577975",
      "mo_avg_art_price": 278.89921507064366,
      "id_prty": 1,
      "vendor_name": "ХЕНКЕЛЬ РУС ООО",
      "mo_mrgn_total": 31602.96
    },
    {
      "vendor_code": "14014",
      "nm_itm": "(96049) ЛИСМА ЧАЙ ЧЕРН КРЕПК 25ПХ2Г",
      "mo_sls": 706435.54,
      "itm_internal_code": "96049",
      "mo_avg_art_price": 36.29260416131518,
      "id_prty": 1,
      "vendor_name": "\"МАЙ-ФУДС\"ООО",
      "mo_mrgn_total": 151380.45
    },
    {
      "vendor_code": "9791",
      "nm_itm": "(235819) КЕФИР ПРО 2,5% 430Г",
      "mo_sls": 699471.02,
      "itm_internal_code": "235819",
      "mo_avg_art_price": 40.15794121024228,
      "id_prty": 1,
      "vendor_name": "\"ДАНОН ТРЕЙД\"ООО 8",
      "mo_mrgn_total": 147822.61
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(866253) CТАЙЛЕР С 1 КАССЕТОЙ FUS PROGL",
      "mo_sls": 699279.25,
      "itm_internal_code": "866253",
      "mo_avg_art_price": 1203.578743545611,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 3805.84
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(283993) БР ОДН BLUE SIMPLE3 8ШТ GIL",
      "mo_sls": 693722.97,
      "itm_internal_code": "283993",
      "mo_avg_art_price": 279.2765579710145,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 53158.08
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(22929) ПЕНА Д/БР ЗАЩ И УХОД 200 NIVEA",
      "mo_sls": 693247.03,
      "itm_internal_code": "22929",
      "mo_avg_art_price": 157.198873015873,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 114596.53
    },
    {
      "vendor_code": "2514",
      "nm_itm": "(183498) НИВ СР-ВО Д/СНЯТ ДВОЙНОЙ ЭФ125",
      "mo_sls": 681685.76,
      "itm_internal_code": "183498",
      "mo_avg_art_price": 183.44611410118407,
      "id_prty": 1,
      "vendor_name": "БАЙЕРСДОРФ ООО",
      "mo_mrgn_total": 92592.81
    },
    {
      "vendor_code": "432",
      "nm_itm": "(650328) АНГЛ.ЗАВТР.200Г. ЧАЙ АХМАД ТИ",
      "mo_sls": 679656.12,
      "itm_internal_code": "650328",
      "mo_avg_art_price": 252.4725557206538,
      "id_prty": 1,
      "vendor_name": "ООО СДС-ФУДС",
      "mo_mrgn_total": 371341.53
    },
    {
      "vendor_code": "4153",
      "nm_itm": "(243351) GM ТВ 101 ЗЕР+СЛ 5% 130ЧЕРНИКА",
      "mo_sls": 665172.79,
      "itm_internal_code": "243351",
      "mo_avg_art_price": 54.47770597870598,
      "id_prty": 1,
      "vendor_name": "САВУШКИН ПРОДУКТ ООО",
      "mo_mrgn_total": 172963.06
    },
    {
      "vendor_code": "1727",
      "nm_itm": "(293593) LIPTON БАЙХ ЭРЛ ГРЕЙ 24X25ПХ2Г",
      "mo_sls": 664855,
      "itm_internal_code": "293593",
      "mo_avg_art_price": 47.08938310078617,
      "id_prty": 1,
      "vendor_name": "ЮНИЛЕВЕР РУСЬ ООО 2",
      "mo_mrgn_total": 104744.25
    },
    {
      "vendor_code": "9839",
      "nm_itm": "(322427) GILLETE FUSION POWER СТ Д/БР",
      "mo_sls": 662370.6,
      "itm_internal_code": "322427",
      "mo_avg_art_price": 603.251912568306,
      "id_prty": 1,
      "vendor_name": "ПРОКТЕР ЭНД ГЭМБЛ ООО 4",
      "mo_mrgn_total": 69775.26
    }
  ],
  "Error": 0,
  "Msg": "",
  "Version": "1"
};
